<template>
  <el-dialog v-model="is_show_dialog" class="add-product-popup" width="460px" :destroy-on-close="true">
    <header class="head">
      <i @click="is_show_dialog = false"><svg-icon name="close" /></i>
      <h2>Add a product</h2>
    </header>
    <ul class="add-list">
      <li class="tag-item" @click="emit('add-by', 'catalog')">
        <div class="info">
          <h3>From {{ props.brand_name }} catalog</h3>
          <p>Add from {{ handleName(props.brand_name) }} database of products.</p>
        </div>
        <i><svg-icon name="arrow-right" /></i>
      </li>
      <li class="tag-item" @click="emit('add-by', 'url')">
        <div class="info">
          <h3>By product URL</h3>
          <p>Add an item using a link from {{ handleName(props.brand_name) }} website.</p>
        </div>
        <i><svg-icon name="arrow-right" /></i>
      </li>
      <li class="tag-item" @click="emit('add-by', 'storefront')" v-if="get_type !== 'storefront'">
        <div class="info">
          <h3>From your curated products</h3>
          <p>Select from products you’ve already added.</p>
        </div>
        <i><svg-icon name="arrow-right" /></i>
      </li>
    </ul>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { ElDialog } from 'element-plus';

const emit = defineEmits(['add-by']);
// const app = getCurrentInstance();
// const DownloasUrl = ref(app.appContext.config.globalProperties.$DownloasUrl);
const is_show_dialog = ref(false);
const props = defineProps({
  brand_name: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'storefront',
  },
});

const get_type = ref(props.type);
const content_id = ref(0);

const open = (obj) => {
  if (obj) {
    get_type.value = obj.type;
    content_id.value = obj.id || 0;
  } else {
    get_type.value = props.type;
  }

  is_show_dialog.value = true;
};

const close = () => {
  is_show_dialog.value = false;
};

const handleName=(name)=>{
  return name.endsWith(`'s`) ? name : name.endsWith(`'`) ? name + 's' : name + `'s`;
}

defineExpose({
  open,
  close,
});
</script>

<style lang="scss">
.add-product-popup {
  padding: 0;

  .el-dialog__header {
    display: none;
  }

  .head {
    display: flex;
    align-items: center;
    padding: 16px 16px 12px;

    i {
      cursor: pointer;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 4px 0 0;
      color: var(--Text-primary);

      svg {
        width: 16px;
        height: 16px;
      }
    }

    h2 {
      font: var(--medium-20);
      color: var(--Text-primary);
    }

    @media screen and (max-width: $mobile_size) {
      i {
        width: 22px;
        height: 22px;

        svg {
          width: 12px;
          height: 12px;
        }
      }

      h2 {
        font: var(--medium-16);
      }
    }
  }

  .add-list {
    padding: 0 16px 4px;
    margin: 0;
    list-style: none;
  }

  .tag-item {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid var(--Border-default);
    cursor: pointer;
    border-radius: var(--radius);
    margin: 12px 0;
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--Neu-20);
      border-color: var(--Neu-40);
    }

    .info {
      flex: 1;

      h3 {
        font: var(--medium-16);
        color: var(--Text-primary);
        margin-bottom: 6px;
      }

      p {
        font-size: 12px;
        color: var(--Text-secondary);
      }
    }

    i {
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      svg {
        height: 12px;
        width: 12px;
        fill: var(--Text-default);
        display: block;
      }
    }
  }
}
</style>
